import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  CardSubtitle,
  Label,
  Input,
  Container,
  FormFeedback,
  Form,
  InputGroup,
} from "reactstrap"
import Select from "react-select"
import makeAnimated from "react-select/animated"

//Import Breadcrumb
import Breadcrumbs from "../../../../components/Common/BreadcrumbBack"

//i18n
import { withTranslation } from "react-i18next"

//redux
import {
  getVariant as onGet,
  deleteVariant as onDelete,
  productsResetError as onClearError,
  clearProduct as onClearProduct,
  updateVariant as onSave
} from "store/actions"
import { useDispatch, useSelector } from "react-redux"

//Custom CSS
import "./../custom.scss"
import moment from "moment"
import Swal from "sweetalert2"
import { Link } from "react-router-dom"
import * as Yup from "yup"
import { useFormik } from "formik"

import { isEmpty } from "lodash"

import Loading from "components/Common/Loading"

const VariantEdit = props => {
  //meta title
  document.title = props.t("Edit Variant")

  const [data, setData] = useState(null)

  const query = new URLSearchParams(props.location.search)

  const breadcrumbItems = [
    { title: props.t("Products"), link: "/v1/products" },
    {
      title: props.t("Variant"),
      link: `/v1/products/variants/${query.get("pid")}`,
    },
    { title: props.t("Edit Variant"), link: "#" },
  ]

  const {
    match: { params },
  } = props

  const dispatch = useDispatch()
  const { error, variant, loading } = useSelector(state => ({
    error: state.Products?.error,
    loading: state.Products?.loading || false,
    variant: state.Products?.variant,
  }))

  useEffect(() => {
    if (!isEmpty(error)) {
      console.error("error", error)
      Swal.fire(
        props.t("Error"),
        error?.error ||
          error?.message ||
          error?.error?.message ||
          JSON.stringify(error),
        "error"
      ).then((isConfirmed)=>{
        if(isConfirmed){
          location.reload();
        }
      })
      dispatch(onClearError())
    }
  }, [error])

  useEffect(() => {
    if (params.id) {
      if (isEmpty(variant)) {
        dispatch(onGet(params.id))
      } else {
        const temp_data = { ...variant }
        setData(temp_data)
        for (let key of Object.keys(validation.values)) {
          try {
            validation.setFieldValue(key, temp_data[key])
          } catch (err) {
            console.error("key converter failed", key, err)
          }
        }
        setTimeout(() => {
          dispatch(onClearProduct())
        }, 300)
      }
    }
  }, [variant])

  // Form validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: "",
      barcode: "", 
      Product: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required(props.t("Required")),
      barcode: Yup.string().required(props.t("Required")),
      // className: Yup.string().required(props.t("Required")),
      // category: Yup.string().required(props.t("Required")),
      // subCategory: Yup.string().required(props.t("Required")),
    }),
    onSubmit: values => {
      console.log("values", values)
      //props.history.push(`/v1/products/create/step2/01`)
      dispatch(onSave(params.id, values, props.history))
    },
  })

  const insert = (arr, index, ...newItems) => [
    // part of the array before the specified index
    ...arr.slice(0, index),
    // inserted items
    ...newItems,
    // part of the array after the specified index
    ...arr.slice(index),
  ]

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Variant")}
            backLink={`/v1/products/variants/${query.get("pid")}`}
            breadcrumbItems={breadcrumbItems}
          />
          <Loading status={loading} />
          <Row>
            <Col md={12}>
              <Card>
                <CardBody>
                  <h4 className="card-title">{props.t("Edit Variant")}</h4>
                  <p className="card-title-desc">
                    {props.t("Edit Variant Description")}
                  </p>
                  <Form
                    className="needs-validation"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="validationCustom01">
                            {props.t("Variant Name")}
                          </Label>
                          <Input
                            name="name"
                            placeholder={props.t("Variant Name")}
                            type="text"
                            className="form-control"
                            id="validationCustom01"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.name || ""}
                            invalid={
                              validation.touched.name && validation.errors.name
                                ? true
                                : false
                            }
                          />
                          {validation.touched.name && validation.errors.name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.name}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="validationCustom01">
                            {props.t("Barcode")}
                          </Label>
                          <Input
                            name="barcode"
                            placeholder={props.t("Barcode")}
                            type="text"
                            className="form-control"
                            id="validationCustom01"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.barcode || ""}
                            invalid={
                              validation.touched.barcode &&
                              validation.errors.barcode
                                ? true
                                : false
                            }
                          />
                          {validation.touched.barcode &&
                          validation.errors.barcode ? (
                            <FormFeedback type="invalid">
                              {validation.errors.barcode}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col> 
                    </Row>
                    <Button color="primary" type="submit">
                      {props.t("Save")}
                    </Button>
                    <Button
                      color="danger"
                      className="ms-2"
                      onClick={() => {
                        Swal.fire({
                          title: props.t("Are You Sure"),
                          text: props.t("DeleteWarning"),
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: props.t("Yes, delete it!"),
                          cancelButtonText: props.t("Cancel"),
                        }).then(result => {
                          if (result.isConfirmed) {
                             dispatch(onDelete(params.id, props.history))
                          }
                        }) 
                      }}
                    >
                      {props.t("Delete")}
                    </Button>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

VariantEdit.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
}

export default withTranslation()(VariantEdit)
